<template>
    <vue-modal
        v-model="visible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="true"
        :modalBodyClass="$prefixClass.modal + '-image-limit text-center' "
    >
        <h4 class="m-b-16">{{title}}</h4>
        <span class="m-b-24" v-html="description"></span><br>
        <div class="image-limit__actions m-t-24">
            <a-button class="m-b-8" type="primary" @click="buyMoreImages"> {{$t('optimize_image.buttons.buy_more_images')}} </a-button><br>
            <a-button v-if="isOptimizeTheme" type="subtle" @click="onOptimizeTheme"> {{$t('optimize_image.buttons.optimize_theme_only')}} </a-button>
            <a-button class="text-color-secondary" v-else type="subtle" @click="visible = false"> {{$t('app.buttons.later')}} </a-button>
        </div>
    </vue-modal>
</template>
<script>
export default {
    name: "ModalDataSynced",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        isOptimizeTheme: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'You reached limit of image'
        },
        description: {
            type: String,
            default: 'Your image reaches limit this month.<br>You can buy more images to continue optimize.'
        }
    },
    data() {
        return {

        }
    },
    computed: {
        visible: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        onOptimizeTheme() {
            this.visible = false
            this.$emit('on-optimize-theme')
        },
        buyMoreImages() {
            this.visible = false
            this.$emit('buy-more-images')
        }
    }
}
</script>
<style lang="scss">
    .m-modal-image-limit {
        .m-modal {
            &-body {
                padding: 40px;
            }
        }
    }
</style>
